import apiClient from '../client'

export const accessibilityService = {
    // Scan URL (main endpoint)
    scanUrl: async (scanData) => {
        const response = await apiClient.post('/accessibility/scan-rendered', scanData)
        return response.data
    },

    // Scan URL (legacy endpoint - for backward compatibility)
    scanUrlLegacy: async (url, wcagLevel = 'wcag2aa') => {
        const response = await apiClient.post('/scan', {
            url,
            wcagLevel,
        })
        return response.data
    },

    // Get scan history
    getScanHistory: async (filters = {}) => {
        const params = new URLSearchParams()
        if (filters.url) {
            params.append('url', filters.url)
        }
        if (filters.websiteConnectionId) {
            params.append('websiteConnectionId', filters.websiteConnectionId)
        }
        if (filters.limit) {
            params.append('limit', filters.limit)
        }
        if (filters.page) {
            params.append('page', filters.page)
        }

        const queryString = params.toString()
        const url = queryString ? `/accessibility/history?${queryString}` : '/accessibility/history'
        const response = await apiClient.get(url)
        return response.data
    },

    // Get latest scan
    getLatestScan: async (url) => {
        const params = new URLSearchParams()
        if (url) {
            params.append('url', url)
        }
        const queryString = params.toString()
        const apiUrl = queryString ? `/accessibility/latest?${queryString}` : '/accessibility/latest'
        const response = await apiClient.get(apiUrl)
        return response.data
    },

    // Get scan by ID (full detail with violations)
    getScanById: async (scanId) => {
        const response = await apiClient.get(`/accessibility/scans/${scanId}`)
        return response.data
    },

    // Get scans by website
    getScansByWebsite: async (websiteConnectionId, pagination = {}) => {
        const params = new URLSearchParams()
        if (pagination.limit) {
            params.append('limit', pagination.limit)
        }
        if (pagination.page) {
            params.append('page', pagination.page)
        }

        const queryString = params.toString()
        const url = queryString
            ? `/accessibility/websites/${websiteConnectionId}/scans?${queryString}`
            : `/accessibility/websites/${websiteConnectionId}/scans`
        const response = await apiClient.get(url, { timeout: 300000 })
        return response.data
    },

    // Get violations by website
    getViolationsByWebsite: async (websiteConnectionId, filters = {}) => {
        const params = new URLSearchParams()
        if (filters.isFixed !== undefined) {
            params.append('isFixed', filters.isFixed)
        }
        if (filters.impact) {
            params.append('impact', filters.impact)
        }
        if (filters.limit) {
            params.append('limit', filters.limit)
        }
        if (filters.page) {
            params.append('page', filters.page)
        }

        const queryString = params.toString()
        const url = queryString
            ? `/accessibility/websites/${websiteConnectionId}/violations?${queryString}`
            : `/accessibility/websites/${websiteConnectionId}/violations`
        const response = await apiClient.get(url)
        return response.data
    },

    // Get website statistics
    getWebsiteStats: async (websiteConnectionId) => {
        const response = await apiClient.get(`/accessibility/websites/${websiteConnectionId}/stats`)
        return response.data
    },

    // Health check
    healthCheck: async () => {
        const response = await apiClient.get('/accessibility/health')
        return response.data
    },

    // Save scan schedule
    saveScanSchedule: async (scheduleData) => {
        const response = await apiClient.post('/accessibility/scan-schedule', scheduleData)
        return response.data
    },
}
